export const PatientMessage = {
  flow: 'y',
  alignSelf: 'flex-end',
  maxWidth: '75%',
  gap: 'W',
  Bubble: {
    padding: 'Z A',
    round: 'A',
    background: 'inkMid',
    color: 'inkText',
    fontSize: 'Z',
    text: (el, s) => s.text || ''
  },
  Timestamp: { text: (el, s) => s.timestamp || '', fontSize: 'Y', color: 'inkMuted', alignSelf: 'flex-end' }
}

export const ClinicMessage = {
  flow: 'y',
  alignSelf: 'flex-start',
  maxWidth: '75%',
  gap: 'W',
  Bubble: {
    padding: 'Z A',
    round: 'A',
    background: 'inkSurface',
    borderLeft: '3px solid teal',
    color: 'inkText',
    fontSize: 'Z',
    text: (el, s) => s.text || ''
  },
  Timestamp: { text: (el, s) => s.timestamp || '', fontSize: 'Y', color: 'inkMuted', alignSelf: 'flex-start' }
}

export const SecureMessageThread = {
  flow: 'y',
  gap: '0',
  height: '100%',
  background: 'inkSurface',
  round: 'A',
  overflow: 'hidden',
  border: '1px solid inkBorder',
  Header: {
    flow: 'x',
    align: 'center space-between',
    padding: 'Z A',
    borderBottom: '1px solid inkBorder',
    background: 'inkMid',
    ThreadTitle: { text: (el, s) => s.threadTitle || 'Secure Message', fontSize: 'A', fontWeight: '600', color: 'inkText' },
    PatientLabel: { text: (el, s) => s.patientName || 'Patient', fontSize: 'Z', color: 'inkMuted' }
  },
  MessageList: {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    flex: '1',
    overflow: 'auto',
    childrenAs: 'state'
  },
  InputArea: {
    flow: 'x',
    gap: 'Y',
    padding: 'Z A',
    borderTop: '1px solid inkBorder',
    background: 'inkMid',
    align: 'center flex-start',
    MessageInput: {
      extends: 'Input',
      placeholder: 'Type a secure message...',
      flex: '1',
      padding: 'Y Z',
      round: 'Z',
      background: 'inkSurface',
      border: '1px solid inkBorder',
      color: 'inkText',
      fontSize: 'Z'
    },
    SendButton: {
      extends: 'Button',
      text: '{{ send | polyglot }}',
      padding: 'Y Z',
      round: 'Z',
      background: 'teal',
      color: 'white',
      fontWeight: '600',
      fontSize: 'Z',
      cursor: 'pointer',
      flexShrink: '0'
    }
  }
}
